import React from 'react';
import { Bleed, Link, Text } from '@applyboard/crystal-ui';
import { formatExternalUrl, removeScholarshipDescription } from "../utils";
import { useEventTracker } from '@applyboard/ui-utils';
import { useScholarshipPageContext } from "../../contexts";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var InfoBoxItemSubLabel = function InfoBoxItemSubLabel(_ref) {
  var subLabel = _ref.subLabel,
    subLabelLinkUrl = _ref.subLabelLinkUrl;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var _useScholarshipPageCo = useScholarshipPageContext(),
    scholarship = _useScholarshipPageCo.scholarship;
  if (!subLabelLinkUrl) {
    return _jsx(Text, {
      children: subLabel
    });
  }
  return _jsx(Bleed, {
    mt: 3,
    children: _jsx(Link, {
      as: "a",
      href: formatExternalUrl(subLabelLinkUrl) || '',
      variant: "standalone",
      mode: "override_user_choice_and_open_in_new_tab",
      rel: "nofollow noopener",
      onClick: function onClick() {
        trackEvent({
          event: 'Scholarship Page - Info Box - Clicked Source Website',
          data: {
            pageScholarship: removeScholarshipDescription(scholarship)
          }
        });
      },
      children: subLabel
    })
  });
};